// SPDX-FileCopyrightText: © 2024 Schneider Electric
//
// SPDX-License-Identifier: Apache-2.0

// FIXME: TypeScript and Webpack can resolve exports from the package.json
// `exports` field but Rollup can't. `@quartzds/generic-icons-core/*.svg`
// _should_ work but it doesn't.
/* eslint-disable import/no-unresolved */
import checked from '@quartzds/generic-icons-core/dist/checked.svg'
import clear from '@quartzds/generic-icons-core/dist/clear.svg'
import draggable from '@quartzds/generic-icons-core/dist/draggable.svg'
import dropdown from '@quartzds/generic-icons-core/dist/dropdown.svg'
import dropdownClose from '@quartzds/generic-icons-core/dist/dropdown-close.svg'
import externalLink from '@quartzds/generic-icons-core/dist/external-link.svg'
import indeterminate from '@quartzds/generic-icons-core/dist/indeterminate.svg'
import inputDate from '@quartzds/generic-icons-core/dist/input-date.svg'
import inputDatetimeLocal from '@quartzds/generic-icons-core/dist/input-datetime-local.svg'
import inputEmail from '@quartzds/generic-icons-core/dist/input-email.svg'
import inputMonth from '@quartzds/generic-icons-core/dist/input-month.svg'
import inputSearch from '@quartzds/generic-icons-core/dist/input-search.svg'
import inputTel from '@quartzds/generic-icons-core/dist/input-tel.svg'
import inputTime from '@quartzds/generic-icons-core/dist/input-time.svg'
import inputUrl from '@quartzds/generic-icons-core/dist/input-url.svg'
import inputWeek from '@quartzds/generic-icons-core/dist/input-week.svg'
import navigation from '@quartzds/generic-icons-core/dist/navigation.svg'
import next from '@quartzds/generic-icons-core/dist/next.svg'
import statusError from '@quartzds/generic-icons-core/dist/status-error.svg'
import statusInfo from '@quartzds/generic-icons-core/dist/status-info.svg'
import statusWarning from '@quartzds/generic-icons-core/dist/status-warning.svg'

/* eslint-enable import/no-unresolved */
import type { IconLibrary } from './library'

const icons: Record<string, string | undefined> = {
  /* eslint-disable @typescript-eslint/naming-convention */
  clear,
  checked,
  draggable,
  dropdown,
  'dropdown-close': dropdownClose,
  'external-link': externalLink,
  indeterminate,
  'input-month': inputMonth,
  'input-tel': inputTel,
  'input-week': inputWeek,
  'input-url': inputUrl,
  'input-time': inputTime,
  'input-date': inputDate,
  'input-datetime-local': inputDatetimeLocal,
  'input-email': inputEmail,
  'input-search': inputSearch,
  navigation,
  next,
  close: statusError,
  'status-error': statusError,
  'status-info': statusInfo,
  'status-success': checked,
  'status-warning': statusWarning,
  /* eslint-enable @typescript-eslint/naming-convention */
}

const coreLibrary: IconLibrary = {
  name: 'core',
  resolver: (name) => icons[name] ?? '',
}

export default coreLibrary
